import { COMPARE_TO_PREVIOUS_VERSION_COMPONENT_KEYS } from 'constants/componentKeys/compareToPreviousVersion.componentKeys';
import { find, head } from 'lodash';

import { useQueryGetProjectVersionsList } from 'api/queries/getProjectVersionsList.query';

import { prepareVersionSelectTitle } from 'components/common/TreeProgramFilter/VersionSelect/versionSelect.utils';

import { IWidget } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

type Props = {
    projectId?: number | null;
    contractId?: number | null;
    componentKey: IWidget['componentKey'];
};
export const useCustomLatestCompareToVersions = ({ projectId, contractId, componentKey }: Props) => {
    const { data: versionsList, isLoading } = useQueryGetProjectVersionsList({
        projectId: projectId,
        contractId: contractId,
    });

    if (!isLoading && versionsList) {
        const latestVersion = find(versionsList, { isLatest: true });
        const compareVersion = find(versionsList, { isDesignatedBaseline: true });
        const previousVersion = head(versionsList.filter((item) => !item.isLatest));

        return {
            latestVersionId: latestVersion?.id,
            latestVersion: latestVersion,
            compareVersionId: COMPARE_TO_PREVIOUS_VERSION_COMPONENT_KEYS.includes(componentKey)
                ? previousVersion?.id
                : compareVersion?.id,
            latestVersionTitle: prepareVersionSelectTitle(latestVersion),
            compareVersionTitle: prepareVersionSelectTitle(
                COMPARE_TO_PREVIOUS_VERSION_COMPONENT_KEYS.includes(componentKey) ? previousVersion : compareVersion,
            ),
        };
    }
    return {
        latestVersionId: undefined,
        compareVersionId: undefined,
        latestVersionTitle: '',
        compareVersionTitle: '',
    };
};
